import { Container } from "@mui/material";

export interface LandingSectionProps {
    id: string;
    children?: any;
    style: any;
    backgrounImage?: string;
    height?: number;
    className?: string;
}

export default function LandingSection(props: LandingSectionProps) {
    return (
        <div
            className={props.className}
            id={props.id}
            style={{ 
                ...props.style, 
                backgroundImage: props.backgrounImage,
                // Ensure minimum height is respected but allow content to expand
                minHeight: props.height ? `${props.height}px` : 'auto',
                // Prevent overlapping by ensuring proper box-sizing
                boxSizing: 'border-box'
            }}
        >
            <Container 
                sx={{
                    paddingBottom: 5,
                    paddingTop: 5,
                    // Remove duplicate containers and use single responsive container
                    minHeight: 'inherit',
                    // Ensure content doesn't overflow
                    overflow: 'hidden',
                    // Add responsive height handling
                    height: {
                        xs: props.height ? `${props.height}px` : 'auto',
                        sm: props.height ? `${props.height}px` : 'auto', 
                        md: 'auto',
                        lg: 'auto'
                    },
                    // Ensure proper spacing on mobile
                    paddingX: {
                        xs: 2,
                        sm: 3,
                        md: 4
                    }
                }}
            >
                {props.children}
            </Container>
        </div>
    );
}